(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.customElements.get('cart-recommendations')) return;

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;
      this._load();
    }

    async _load() {
      const section = this.closest('.shopify-section');
      if (!section) return;
      const sectionId = section.id.replace(/^shopify-section-/, '');
      const mode = this.getAttribute('intent') || 'complementary_then_related';
      const intents = mode === 'complementary_then_related' ? ['complementary', 'related'] : [mode];

      for (const intent of intents) {
        const url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute('product')}&limit=${this.getAttribute('limit') || 4}&section_id=${sectionId}&intent=${intent}`;
        try {
          const response = await fetch(url, { priority: 'low' });
          if (!response.ok) continue;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const body = doc.querySelector('[data-recommendations-body]');
          if (body) {
            this.replaceChildren(document.importNode(body, true));
            return;
          }
        } catch (error) {
          // fall through to the next intent
        }
      }
      // Nothing to recommend: drop the whole section so no empty gap is left.
      section.remove();
    }
  }

  window.customElements.define('cart-recommendations', CartRecommendations);
})();

  } catch(e) { console.error(e); }
})();
})();
